import { gql } from '@apollo/client';

export const CREATE_VOUCHER = gql`
  mutation createVoucher(
    $amount: Float!
    $type: CreatableVoucherType!
    $validUntil: String!
    $cid: String
    $title: String
    $firstName: String
    $lastName: String
    $recipientEmail: String
    $bookingReference: String
    $currency: Currency!
    $language: Language
    $associatedPNR: String
  ) {
    createVoucher(
      amount: $amount
      type: $type
      validUntil: $validUntil
      cid: $cid
      title: $title
      firstName: $firstName
      lastName: $lastName
      recipientEmail: $recipientEmail
      bookingReference: $bookingReference
      currency: $currency
      language: $language
      associatedPNR: $associatedPNR
    ) {
      alias
    }
  }
`;

export const GET_MANUAL_VOUCHER_BOOKING = gql`
  query manualVoucherBooking($reference: String!) {
    booking(reference: $reference) {
      currency
      totalPrice
      additionalDetails {
        key
        value
      }
    }
  }
`;

export const GET_MANUAL_VOUCHER = gql`
  query manualVoucher($reference: String!, $market: String!) {
    findVoucherByReferenceAndMarket(reference: $reference, market: $market) {
      value
    }
  }
`;
